import { Api } from "src/utils/api";
import { SALES_PERFORMANCE_API_BASE_URL } from "./sales-performance.constant";

export interface MetricResponse {
  period_end: string;
  period_start: string;
  data: {
    period_start: string;
    period_end: string;
    value: number;
  }[];
}

export class SalesPerformanceApi extends Api {
  constructor() {
    super(SALES_PERFORMANCE_API_BASE_URL);
  }

  public getTotalSales = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/sales", {
      date_start,
      date_end,
    });
  };
  public getTotalAcos = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/acos", {
      date_start,
      date_end,
    });
  };
  public getTotalUnitsSold = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/units-sold", {
      date_start,
      date_end,
    });
  };
  public getTotalRoas = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/roas", {
      date_start,
      date_end,
    });
  };
  public getTotalCpc = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/cpc", {
      date_start,
      date_end,
    });
  };
  public getTotalSpend = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/spend", {
      date_start,
      date_end,
    });
  };

  public getTotalClicks = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/clicks", {
      date_start,
      date_end,
    });
  };

  public getTotalOrders = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/orders", {
      date_start,
      date_end,
    });
  };
  public getTotalCvr = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/cvr", {
      date_start,
      date_end,
    });
  };
  public getTotalTacos = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/tacos", {
      date_start,
      date_end,
    });
  };
  public getTotalSalesMetric = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/sales", {
      date_start,
      date_end,
    });
  };
  public getTotalMer = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("total/mer", {
      date_start,
      date_end,
    });
  };
  public getAdSpend = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/spend", {
      date_start,
      date_end,
    });
  };
  public getAdSales = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/sales", {
      date_start,
      date_end,
    });
  };
  public getAdClicks = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/clicks", {
      date_start,
      date_end,
    });
  };
  public getAdImpressions = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/impressions", {
      date_start,
      date_end,
    });
  };

  public getAdCtr = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/ctr", {
      date_start,
      date_end,
    });
  };

  public getAdCvr = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/cvr", {
      date_start,
      date_end,
    });
  };

  public getAdCpc = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/cpc", {
      date_start,
      date_end,
    });
  };

  public getAdAcos = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/acos", {
      date_start,
      date_end,
    });
  };

  public getAdRoas = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/roas", {
      date_start,
      date_end,
    });
  };

  public getAdUnitsSold = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("ad/unit-sold", {
      date_start,
      date_end,
    });
  };
  // CFO Endpoints
  public getCfoAvailableCapital = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/available-capital", {
      date_start,
      date_end,
    });
  };

  public getCfoFrozenCapital = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/frozen-capital", {
      date_start,
      date_end,
    });
  };

  public getCfoBorrowedCapital = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/borrowed-capital", {
      date_start,
      date_end,
    });
  };

  public getCfoLostSales = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/lost-sales", {
      date_start,
      date_end,
    });
  };

  public getCfoGrossMargin = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/gross-margin", {
      date_start,
      date_end,
    });
  };

  public getCfoNetProfit = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/net-profit", {
      date_start,
      date_end,
    });
  };

  public getCfoNetMargin = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/net-margin", {
      date_start,
      date_end,
    });
  };

  public getCfoOpex = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/opex", {
      date_start,
      date_end,
    });
  };

  public getCfoContributionProfit = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/contribution-profit", {
      date_start,
      date_end,
    });
  };

  public getCfoEbitda = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/ebitda", {
      date_start,
      date_end,
    });
  };

  public getCfoRoi = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("cfo/roi", {
      date_start,
      date_end,
    });
  };

  // Organic Endpoints
  public getOrganicSales = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("organic/sales", {
      date_start,
      date_end,
    });
  };
  public getOrganicUnitsSold = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("organic/units-sold", {
      date_start,
      date_end,
    });
  };
  public getOrganicImpressions = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("organic/impressions", {
      date_start,
      date_end,
    });
  };

  public getOrganicClicks = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("organic/clicks", {
      date_start,
      date_end,
    });
  };

  public getOrganicOrders = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("organic/orders", {
      date_start,
      date_end,
    });
  };

  public getOrganicCtr = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("organic/ctr", {
      date_start,
      date_end,
    });
  };

  public getOrganicCvr = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("organic/cvr", {
      date_start,
      date_end,
    });
  };

  public getOrganicCartAdds = async (
    date_start: string,
    date_end: string,
  ): Promise<MetricResponse> => {
    return await this.get("organic/add-to-cart", {
      date_start,
      date_end,
    });
  };
}
